import React from "react";

const PlaylistCover = ({ image }) => {
  return <img src={image} alt="playlist-cover" />;
};

export default PlaylistCover;
